// extracted by mini-css-extract-plugin
module.exports = {"no-input-arrows":"styles_no-input-arrows__gRS_B","colorshadow":"styles_colorshadow__Ukvq4"};